var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app_settings"}},[_c('v-layout',{attrs:{"wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"pa-4":""}},[_c('v-card',{attrs:{"id":"app_height"}},[_c('Settings')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }